import { render } from "./ReportTypeComponent.vue?vue&type=template&id=5a537aff&scoped=true"
import script from "./ReportTypeComponent.vue?vue&type=script&lang=js"
export * from "./ReportTypeComponent.vue?vue&type=script&lang=js"

import "./ReportTypeComponent.vue?vue&type=style&index=0&id=5a537aff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a537aff"]])

export default __exports__